/** @format */

import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Card, Button, CardContent, Divider, Grid } from "@material-ui/core";
import { format, compareAsc } from "date-fns";
import UserContext from "../../context/Globales/UserContext";

//import InformeRessult from './InformeRessult';
import IdentificacionModal from "./IdentificacionModal";
import IndicadoresPositivoNegativoModal from "./IndicadoresPositivoNegativoModal";
import IndicadoresEmpresasModal from "./IndicadoresEmpresasModal";
import AsignacionGraficosModal from "./AsignacionGraficosModal";
import AsignacionTableModal from "./AsignacionTableModal";

import Loading from "../modales/Loading";
import { Box } from "@material-ui/core";
import { TblEstructuraFinancieraModal } from "./TblEstructuraFinancieraModal";

const ViewInformeModal = () => {
  const { datoICMODAL } = useContext(UserContext);

  const productValidation = JSON.parse(
    localStorage.getItem("productvalidation")
  );

  const AlertSinResultModal = (
    <>
      <Card>
        <CardContent>
          <img
            src={
              process.env.PUBLIC_URL + "/static/imagen/algo-ha-salido-mal.png"
            }
            width="30%"
            title="Imagen algo a salido mal"
            alt="algo a salido mal"
          ></img>
          <br />
          <h1>ATENCIÓN </h1>

          <Divider />
          <p>
            No se pudo procesar la solicitud, INTENTE DE NUEVO - SI EL PROBLEMA
            PERSISTE CONTACTE A SOPORTE
          </p>
          {/* <p>{this.state.message}</p> */}
        </CardContent>
      </Card>
    </>
  );

  return (
    <>
      {datoICMODAL.ID === 0 ||
      datoICMODAL.Fecha === null ||
      datoICMODAL == "ERROR INFORME COMERCIAL MODAL" ? (
        <Box
          my={15}
          style={{ textAlign: "center", alignContent: "center", width: "100%" }}
        >
          <AlertSinResultModal />
        </Box>
      ) : (
        ""
      )}

      <div
        className="container"
        hidden={datoICMODAL.Fecha == null ? true : false}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>

            <IdentificacionModal />
          </Grid>

          <br />
          <Grid item xs={12} sm={12} xl={8} md={8} lg={8}>
            <IndicadoresPositivoNegativoModal />

            <AsignacionGraficosModal />

            <br />
            <AsignacionTableModal />
            <br />
          </Grid>

          {productValidation ? (
            <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
              <TblEstructuraFinancieraModal />
            </Grid>
          ) : (
            " "
          )}
        </Grid>
      </div>
    </>
  );
};

export default ViewInformeModal;
